export default __webpack_public_path__ + "static/guidelineImg-b59c6f214aa48431afb2192813966999.webp";